// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Q1-z","dimensionLabel":"R1-z","styleChooserControlWrapper":"S1-z","styleChooserControl":"T1-z","disabled":"U1-z","giftCard":"V1-z","styleChooserText":"W1-z"};